export default {
  en: [
    {
      imgKey: "1",
      name: "Wenwen & A. Ming",
      info: "Thanks to Luumy for letting me find the feeling of being in love. When I first came here, I wanted to try my luck to find a boyfriend, and finally I found the one. He is very kind to me and cares about me very much. I feel very happy being with him.",
    },
    {
      imgKey: "2",
      name: "LiLy & Vincent",
      info: "On Luumy, I found a good friend to chat with. We came from different countries. He spoke very interestingly and gave me a lot of advice on life and work.",
    },
    {
      imgKey: "3",
      name: "mai phuong thao & Trần Văn Đàm",
      info: `A celebrity said: "There is always a person waiting for you in this world, no matter when, no matter where, anyway, you know, there is always such a person.". We found each other here.`,
    },
    {
      imgKey: "4",
      name: "Ryan",
      info: "I met a group of interesting friends who played games with me and talked with me. I can't live without these friends, and I think this platform is very helpful for me to open up my social circle.",
    },
  ],
};
